import { render, staticRenderFns } from "./switchButton.vue?vue&type=template&id=41d8d4b6"
import script from "./switchButton.vue?vue&type=script&lang=js"
export * from "./switchButton.vue?vue&type=script&lang=js"
import style0 from "./switchButton.vue?vue&type=style&index=0&id=41d8d4b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports